import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import routes from '@root/routes';
import { locationType } from '@propTypes';
import s from './SidebarMenu.module.less';

export const getSelectedKeysFrom = pathname => {
  if (pathname.startsWith(routes.admin.buildingSearch)) return ['buildings'];
  if (pathname.startsWith(routes.admin.userSearch)) return ['users'];
  if (pathname.startsWith(routes.admin.companies)) return ['companies'];
  if (pathname.startsWith(routes.admin.listingSearch)) return ['listings'];
  if (pathname.startsWith(routes.admin.landlords)) return ['landlords'];
  if (pathname.startsWith(routes.admin.tourbookExportTool)) return ['tourbookExportTool'];
  return [];
};

const SidebarMenu = ({ location, requestedListingsCount }) => {
  const { t } = useTranslation('admin');
  const selectedKeys = getSelectedKeysFrom(location.pathname);

  return (
    <Menu mode="inline" selectedKeys={selectedKeys} className={s.menu}>
      <Menu.Item key="buildings">
        <Link to={routes.admin.buildingSearch}>{t('sidebar.buildingsLink')}</Link>
      </Menu.Item>
      <Menu.Item key="listings">
        <Link to={routes.admin.listingSearch}>
          {requestedListingsCount > 0
            ? t('sidebar.listingsLinkWithCount', { count: requestedListingsCount })
            : t('sidebar.listingsLink')}
        </Link>
      </Menu.Item>
      <Menu.Item key="users">
        <Link to={routes.admin.userSearch}>{t('sidebar.usersLink')}</Link>
      </Menu.Item>
      <Menu.Item key="companies">
        <Link to={routes.admin.companies}>{t('sidebar.companiesLink')}</Link>
      </Menu.Item>
      <Menu.Item key="landlords">
        <Link to={routes.admin.landlords}>{t('sidebar.landlordsLink')}</Link>
      </Menu.Item>
      <Menu.Item key="tourbookExportTool">
        <Link to={routes.admin.tourbookExportTool}>{t('sidebar.tourbookExportToolLink')}</Link>
      </Menu.Item>
    </Menu>
  );
};

SidebarMenu.propTypes = {
  location: locationType.isRequired,
  requestedListingsCount: PropTypes.number.isRequired,
};
export default withRouter(SidebarMenu);
